import { Layout } from 'antd';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { isValidAuthSession } from '../../../util/authSession';
import { Loading } from '../../components/Loading';
import { LoginForm } from '../../components/LoginForm';
import './styles.css';

export const Login = () => {
  const userAuth = useSelector((state) => state.userAuth);
  const hasValidSession = isValidAuthSession(userAuth);

  return (
    <>
      {hasValidSession ? (
        <Navigate to={`/dashboard/${userAuth.path}`} replace />
      ) : (
        <>
          <Loading />
          <Layout>
            <div className="bg-login">
              <LoginForm />
            </div>
          </Layout>
        </>
      )}
    </>
  );
};
